<script>

import Textbox from '@/components/Textbox'
import Btn from '@/components/Btn'
import LoginRegisterSwitcher from '@/components/LoginRegisterSwitcher'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'Restore',
  components: {
    Textbox,
    Btn,
    LoginRegisterSwitcher
  },
  data () {
    return {
      username: '',
      reseted: false
    }
  },
  computed: {
    className () {
      return this.$v.$error ? 'shake animated' : ''
    },
    flipperClassName () {
      return this.reseted ? 'rotate' : ''
    }
  },
  validations: {
    username: {
      required
    }
  },
  methods: {
    reset () {
      this.$api.restore({
        username: this.username
      }).then(() => {
        this.reseted = true
      }).catch(() => {
        this.$toast.show({
          text: 'Сожалеем. Что-то пошло не так.'
        })
      })
    }
  }
}

</script>

<template lang="pug">

.wrapper.flip-wrapper
  .login.flipper(:class="flipperClassName")
    .flip-front(:class="className")
      .form
        .inline-block.margin-bottom {{ $t('Для восстановления пароля введите ваш логин') }}
        textbox(v-model="username", :validator="$v.username")
        .has-error(v-if="$v.username.$error") {{ $t('Введите логин.') }}
        .row.margin-top-5x
          .col-xs-6.line-height-3x
            router-link.text-light(style="color: #000", :to="{ name: 'login' }") {{ $t('ВСПОМНИЛ!') }}
          .col-xs-6.text-right
            btn(@click="reset", :disabled="$v.$invalid") {{ $t('Сбросить') }}
    .flip-back
      .form
        login-register-switcher.margin-bottom-4x
        .inline-block.margin-bottom-6x {{ $t('Проверьте вашу почту — там инструкции по восстановлению пароля.') }}
        .text-right
          btn(@click="$router.push({ name: 'login' })", :disabled="$v.$invalid") {{ $t('Готово') }}

</template>

<style scoped lang="sass">

.wrapper
  padding-top: 100px

.login
  width: 350px
  margin: auto

.form
  padding: 25px 20px
  background: #FFFFFF

.line
  height: 1px
  background: #ECECEC
  width: 185px
  margin: 0 auto $vertical-step auto

</style>
